import { ApiService } from '../../services/api_service';
import { DataService } from '../../services/data_service';
import DialogWrapper2 from '../../core/dialog/dialog_wrapper_v2';
import { getWetterstation } from './functions/getWetterstation';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import { onFormChangeUniversal } from './functions/onFormChange';
import * as React from 'react';
import { StandorteDetail } from './detail/StandorteDetail';
import { TriggerService } from '../../core/trigger/trigger_service';
import { validateFieldUniversal } from './functions/validateField';
import { WActionButton } from '../../core/elements/WActionButton';
import { WFormData } from '../../core/forms/WFormData';
import { WFormsTableWrapper } from '../../core/table/WFormsTableWrapper';
import { WMap } from './map/Wmap';
import { getCustomFormConfig } from './co2_custom/getCustomFormConfig';
import * as config from '../../wips.config.js';

export interface DateneingabeBetrieblicheDatenVeranstaltungenProps {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
    standortSelected: any;
}

export interface DateneingabeBetrieblicheDatenVeranstaltungenState {
    rowForDialog: any;
    rowForGps: any;
    refreshStamp: number;
    bundleFilterFunc: (bundle: any) => void;
}

export class DateneingabeBetrieblicheDatenVeranstaltungen extends
    React.Component<DateneingabeBetrieblicheDatenVeranstaltungenProps, DateneingabeBetrieblicheDatenVeranstaltungenState> {

    constructor(props: any) {
        super(props);
        this.state = {
            rowForDialog: undefined,
            rowForGps: undefined,
            refreshStamp: new Date().getTime(),
            bundleFilterFunc: this.bundleFilterFunc
        };
        this.onAfterClose = this.onAfterClose.bind(this);
        this.onDataLoaded = this.onDataLoaded.bind(this);
        this.onFormChange = this.onFormChange.bind(this);
        this.onFormChangeInteractive = this.onFormChangeInteractive.bind(this);
        this.preFilter = this.preFilter.bind(this);
        this.validateField = this.validateField.bind(this);
        this.setUnternehmensdatenInHauptsitz = this.setUnternehmensdatenInHauptsitz.bind(this);
        this.customFormConfigFunc = this.customFormConfigFunc.bind(this);
        this.bundleFilterFunc = this.bundleFilterFunc.bind(this);
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    private lastAdressString: string;

    componentDidMount(): void {
        this.setUnternehmensdatenInHauptsitz();
    }

    onAfterClose(): void {
        const routing = this.props.routing;
        if (routing.standort) {
            routing.standort = undefined;
            this.props.onRoutingChange(routing);
        }
        this.setState({ rowForDialog: undefined });
    }

    onDataLoaded(rows: Array<any>): void {
        // console.log('Standorte Loaded: ', rows, this.props.routing);
        if (this.props.routing && this.props.routing[IDs.ENT_STANDORT]) {
            const rowFound = rows.find((row: any) => row.tid === this.props.routing[IDs.ENT_STANDORT]);

            if (rowFound) {
                this.setState({ rowForDialog: rowFound });
            }
        }
    }

    onFormChange(WFormData: any): void {
        const bundleFilterFunc = this.bundleFilterFunc;
        this.setState({ bundleFilterFunc, refreshStamp: new Date().getTime() });
        onFormChangeUniversal(IDs.ENT_STANDORT, WFormData, this, this.props.data);
    }

    async onFormChangeInteractive(formData: WFormData, onValueChange: (name: string, value: any) => void): Promise<void> {
        const strasse = formData.getAllValues().strasse;
        const hausnummer = formData.getAllValues().hausnummer;
        const plz = formData.getAllValues().hausnummer;
        const standort_tid = formData.getAllValues().standort_tid;
        console.log('oFC', formData.getAllValues());
        this.lastAdressString = await getWetterstation(this.props.data, this.lastAdressString, formData, onValueChange);
    }

    preFilter(data: Array<any>): any {
        const { standortSelected } = this.props;
        data = data.filter((item: any) => +item.standort_typ_tid_orig === 5 || +item.standort_typ_tid_orig === 6);
        return standortSelected
            ? data.filter((item: any) => (+item.tid || null) === standortSelected.tid)
            : data;
    }

    render(): JSX.Element {
        if (!this.props.data) {
            return null;
        }
        const isAdmin: boolean = this.apiService.isAdmin() || false;
        const customActions = [
            {
                label: 'Standort bearbeiten',
                key: 'edit',
                func: (row: any) => this.setState({ rowForDialog: row }),
                info: 'Standort bearbeiten'
            },
            {
                label: 'GPS-Verortung',
                key: 'map_open',
                func: (row: any) => this.setState({ rowForGps: row }),
                info: 'GPS-Verortung'
            }
        ];

        if (!isAdmin) {
            delete customActions[1];
        }
        const tblKey = this.props.data[IDs.ENT_STANDORT].map((o: any) => o.ort).join('_');
        // console.log('RenderStandorte', this.props.data[IDs.ENT_STANDORT]);
        // ***********************************
        // Hinweis: Den Detail-Dialog der Standorte habe ich erstmal deaktiviert
        // Statt dessen gibt es wieder das Standard-Edit ...
        return (
            <div>
                <WFormsTableWrapper
                    refreshStamp={this.state.refreshStamp}
                    entity={IDs.ENT_STANDORT}
                    module={IDs.MOD_ETOOL}
                    key={tblKey}
                    data={this.props.data[IDs.ENT_STANDORT]}
                    actions={['add', 'edit', 'delete']}
                    customClass={'Custom-ETA'}
                    formLayout={'flowV2'}
                    addLabel='Neue Veranstaltung erfassen'
                    customActions={[] /*customActions*/}
                    customFormConfig={{
                        gruppe: { hidden: true }
                    }}
                    hiddenColumns={['gruppe']}
                    customFormConfigFunc={this.customFormConfigFunc}
                    onFormChange={this.onFormChange}
                    onFormChangeInteractive={this.onFormChangeInteractive}
                    validateField={this.validateField}
                    validRestriction='stop'
                    disableFieldSelectDefaultOptions={{ standort_typ_tid: true }}
                    formPreset={{ standort_typ_tid: 5 }}
                    preFilterFunction={this.preFilter}
                    showColumnsHelp={true}
                    onDataLoaded={this.onDataLoaded} // Aktuell nur fürs Routing
                    externalHeaderElements={[/*<WActionButton
                        label='Unternehmensdaten für Hauptsitz übernehmen'
                        insideText='Unternehmensdaten für Hauptsitz übernehmen'
                        tooltip='Unternehmensdaten für Hauptsitz übernehmen'
                        key='copy'
                        action='copy'
                        onAction={this.setUnternehmensdatenInHauptsitz}
                    />*/]}
                    formSimpleValidationMsg={['energiedaten_erfassen']}
                    globalData={this.props.data}
                    bundleFilterFunc={this.state.bundleFilterFunc}
                    // onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_STANDORT)}
                    onAfterAction={(action: string) => {
                        if (action === 'saveDone' || action === 'delDone') {
                            this.triggerService.fire('reload', IDs.ENT_STANDORT);
                        }
                    }}
                />
                {this.state.rowForDialog &&
                    <div>
                        <DialogWrapper2
                            width={-1}
                            onAfterClose={this.onAfterClose}
                        >
                            <StandorteDetail
                                data={this.props.data}
                                onRoutingChange={this.props.onRoutingChange}
                                routing={this.props.routing}
                                standortSelected={this.state.rowForDialog}
                            />
                            <div style={{ textAlign: 'right', marginRight: 4 }}>
                                {this.renderCloseButton()}
                            </div>
                        </DialogWrapper2>
                    </div>
                }
                {this.state.rowForGps &&
                    <div>
                        <DialogWrapper2
                            width={530}
                            onAfterClose={() => this.setState({ rowForGps: undefined })}
                        >
                            <WMap
                                lat={this.state.rowForGps.latitude ? this.state.rowForGps.latitude : null}
                                long={this.state.rowForGps.longitude ? this.state.rowForGps.longitude : null}
                                data={this.state.rowForGps}
                                entity={IDs.ENT_STANDORT}
                                edittable={true}
                                onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_STANDORT)}
                            />
                        </DialogWrapper2>
                    </div>
                }
            </div>
        );
    }

    setUnternehmensdatenInHauptsitz(): void {
        const { data } = this.props;
        if (Array.isArray(data[IDs.ENT_UNTERNEHMENSDATEN]) && data[IDs.ENT_UNTERNEHMENSDATEN].length > 0 &&
            Array.isArray(data[IDs.ENT_STANDORT]) && data[IDs.ENT_STANDORT].length > 0) {
            const unt = data[IDs.ENT_UNTERNEHMENSDATEN][0];
            const hauptList = data[IDs.ENT_STANDORT]
                .filter((s: any) => s.standort_typ_tid_orig === 1 &&
                    (s.strasse !== unt.strasse || s.hausnummer !== unt.hausnummer || s.ort !== unt.ort || s.plz !== unt.plz))
                .map((s: any) => {
                    const row: any = {
                        strasse: s.strasse,
                        hausnummer: s.hausnummer,
                        ort: s.ort,
                        plz: s.plz,
                        ort_gtz: s.ort_gtz,
                    };
                    Object.keys(row).forEach((k: string) => {
                        if (!row[k] && unt[k]) {
                            row[k] = unt[k];
                        }
                    });
                    row.tid = s.tid;
                    return row;
                });
            if (hauptList.length > 0) {
                hauptList.forEach((h: any) => {
                    const idx = data[IDs.ENT_STANDORT].findIndex((s: any) => s.tid === h.tid);
                    if (idx >= 0) {
                        const dataOrig = data[IDs.ENT_STANDORT][idx];
                        data[IDs.ENT_STANDORT][idx] = { ...dataOrig, ...h };
                    }
                });
                this.dataService.saveDataList(IDs.ENT_STANDORT, hauptList, () => {
                    this.triggerService.fire('reload', IDs.ENT_STANDORT);
                }, IDs.MOD_ETOOL);
            }
        }
    }

    renderCloseButton(): JSX.Element {
        return (
            <WActionButton
                label='Schließen'
                insideText='Schließen'
                key='close'
                action='delete'
                onAction={this.onAfterClose}
            />
        );
    }

    validateField(key: string, value: any, data: any, onValueChange: (name: string, value: any) => void): string {
        return validateFieldUniversal(IDs.ENT_STANDORT, key, value, data, onValueChange, this.props.data);
    }
    customFormConfigFunc(formConfig: any, formData: any) {
        formConfig.name = 'Veranstaltung';
        if (formConfig && formConfig.items && formData && formData.values) {
            const config = getCustomFormConfig(IDs.ENT_STANDORT, formData.values, this.props.data);
            // console.log('VA cFC', config, formConfig.items);
            Object.keys(config).forEach((k: string) => {
                const idx = (formConfig.items || []).findIndex((c: any) => c.key === k);
                // console.log('VA cFC', k, idx);
                if (idx >= 0) {
                    formConfig.items[idx].hidden = config[k].hidden;
                }
            });
        }
    }

    bundleFilterFunc(bundle: any) {
        // console.log('Bundle VA:', bundle);
        bundle.standort_typ_tid = bundle.standort_typ_tid.filter((item: any) => +item.tid === 5 || +item.tid === 6);
        bundle.standort_tid = bundle.standort_tid.filter((item: any) => +item.standort_typ_tid_orig !== 5 && +item.standort_typ_tid_orig !== 6);
        return bundle;
    }
}

